import {
  applySnapshot, flow, getEnv, types,
} from 'mobx-state-tree';
import { toast } from 'react-hot-toast';
import {
  UserActivity,
  UserActivityListData,
  UserActivityListParams,
  ListMetaDataModel,
} from '../types';
import { DEFAULT_META } from '../constants';

export const UserActivityStoreModel = types.model('UserActivityStore', {
  items: types.optional(types.array(types.frozen<UserActivity>()), []),
  meta: types.optional(ListMetaDataModel, DEFAULT_META),
})
  .actions((self) => ({
    fetchUserActivity: flow(function* (userId: number, params?: UserActivityListParams) {
      try {
        const res = yield getEnv(self).api.fetchUserLogs(userId, params);
        const { items, meta } = res as UserActivityListData;
        applySnapshot(self.items, items);
        self.meta = meta;
      } catch (e) {
        toast.error('Failed to fetch user activity');
      }
    }),
    fetchActivityById: flow(function* (id: string) {
      try {
        const res = yield getEnv(self).api.fetchUserLogById(id);
        applySnapshot(self.items, [res]);
      } catch (e) {
        toast.error('Failed to fetch activity record');
      }
    }),
  }))
  .views((self) => ({
    // eslint-disable-next-line max-len
    getActivityById: (id: string): UserActivity | undefined => self.items.find((item) => item.id === Number(id)),
  }));

// eslint-disable-next-line max-len
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/explicit-function-return-type
export const createUserActivityStoreModel = () => types.optional(UserActivityStoreModel, {});
